export const toKebabCase = (text: string | undefined | null) => {
	if (!text) {
		return '';
	}

	return text.toLowerCase().replaceAll(' ', '-');
};
